export default __webpack_public_path__ + "static/media/complete_il.c5d4e186.svg";